import { ChangeDetectionStrategy, Component, type ElementRef, Input, ViewChild } from '@angular/core';
import { SharedPipesModule } from '@reconcept-platform/shared/util';

@Component({
  selector: 'rcp-file-preview-video',
  styleUrls: ['./file-preview-video.component.scss'],
  template: `
    <video controls [src]="previewFileURL | safeSrc" #player>
      <a [href]="previewFileURL"> Download video </a>
    </video>
  `,
  imports: [SharedPipesModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilePreviewVideoComponent {
  @Input()
  previewFileURL: string;

  @ViewChild('player')
  player: ElementRef;

  pause() {
    this.player?.nativeElement?.pause();
  }
}
